import { selfExclusion } from "@actions/auth";
import { getUserInfo } from "@actions/profile";
import { getUser } from "@utils";
import { Col, Form, Input, Row } from "antd";
import Button from "antd/lib/button";
import moment from "moment";
import React, { Component } from "react";
import { Translate } from "react-localize-redux";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

const SelfExclusionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	min-height: 156px;
	border-radius: 20px;
	background: var(--profile-page-wrapper-bg);
	padding: 15px 10px;
	gap: 10px;
	margin-bottom: 10px;

	/* Chrome, Safari, Edge, Opera */
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Firefox */
	input[type="number"] {
		-moz-appearance: textfield;
	}

	.two-factor-auth {
		margin-top: 0;
	}

	.ant-input {
		color: var(--content-text-color) !important;
		font-size: 12px !important;
		font-weight: 400 !important;
		line-height: 16px !important;
		letter-spacing: 0.3px !important;
		width: 100%;
		height: 40px;
		padding: 10px 5px 0 20px !important;
		border-radius: 50px;
		border: 1px solid var(--main-explosive);
		background: var(--input-bg-has-value) !important;
	}

	.ant-input[disabled] {
		border: 1px solid var(--main-explosive) !important;
	}

	.ant-input[disabled]:hover {
		border: 1px solid var(--main-explosive);
	}
	.ant-form-item {
		margin-bottom: 0px;
		position: relative;

		.ant-form-item-label {
			position: absolute;
			z-index: 1;
			top: 5px;
			left: 21px;
			height: 12px;
			display: flex;
			align-items: center;

			& > label {
				color: var(--main-secondary-text-color);
				font-size: 10px;
				font-weight: 400;
				line-height: 12px;
				letter-spacing: 0.25px;
				height: 100%;
			}
		}

		&.switch-form-item {
			justify-content: center;
			.ant-form-item-label {
				position: relative;
				width: 85px;
			}
		}
	}

	${window.HAS_LESS_BORDER_RADIUS &&
	css`
		.ant-input {
			border-radius: 10px;
		}

		input {
			border-radius: 10px;
		}

		.ant-form-item textarea.ant-input {
			border-radius: 10px;
		}
	`}
	.two-factor-auth-header {
		color: var(--header-color);
		text-align: center;
		font-size: 12px;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.3px;
	}

	.two-factor-auth-container {
		color: var(--content-text-color);
		text-align: center;
		font-size: 10px;
		font-weight: 400;
		line-height: 12px;
		letter-spacing: 0.25px;
	}

	p {
		margin: 0 0 10px 0;
		min-height: 66px;
		padding: 0 10px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.two-factor-auth-exclude-btn {
		align-items: center;
		display: flex;
		width: 100%;
		justify-content: center;
		border-radius: 25px;

		${window.HAS_LESS_BORDER_RADIUS &&
		css`
			border-radius: 10px;
		`}

		background: var(--sign-in-btn-bg);
		color: var(--button-color);
		opacity: 0.6;

		svg {
			path {
				fill: var(--button-color);
			}
		}
	}

	.ant-btn[disabled],
	.ant-btn[disabled]:hover,
	.ant-btn[disabled]:focus,
	.ant-btn[disabled]:active {
		background: var(--sign-in-btn-bg);
		color: var(--button-color);
		opacity: 0.2;
	}
`;

const SelfExcludedButton = styled.button`
	display: flex;
	min-height: 40px;
	width: 100%;
	justify-content: center;
	align-items: center;
	gap: 10px;
	flex: 1 0 0;
	border: 1px solid var(--main-color);
	background: #0b0610;
	color: var(--main-color);
	text-align: center;
	font-size: 12px;
	font-weight: 600;
	line-height: 16px;
	letter-spacing: 0.75px;
	border-radius: 25px;
`;

const SelfExcludedInfo = styled.p`
	color: var(--content-text-color);
	text-align: center;
	font-feature-settings:
		"clig" off,
		"liga" off;
	font-size: 10px;
	font-style: normal;
	font-weight: 400;
	line-height: 12px; /* 120% */
	letter-spacing: 0.3px;
	width: 100%;
	margin-top: 10px;
`;
export class SelfExclusion extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selfExcluded: false,
			selfExclusionDays: 0,
			selfExclusionStartDate: 0,
			isButtonDisabled: true,
		};
		this.formRef = React.createRef();
	}
	handleSelfExclusion(values) {
		values.isSelfExcluded = true;
		this.props.selfExclusion(values, () => {
			this.getSelfExternalProfileInfo();
		});
	}

	getSelfExternalProfileInfo = () => {
		const fetchedUser = getUser();
		if (fetchedUser) {
			this.props.getUserInfo((res) => {
				this.setState({
					selfExcluded: !!res?.self_excluded,
					selfExclusionDays: res?.self_exclusion_days,
					selfExclusionStartDate: res?.self_exclusion_start,
				});
			});
		}
	};

	componentDidMount() {
		this.getSelfExternalProfileInfo();
	}

	handleFormValuesChange = (changedValues) => {
		if (changedValues.selfExculsionDays) {
			this.setState({ isButtonDisabled: false });
		} else {
			this.setState({ isButtonDisabled: true });
		}
	};

	render() {
		return (
			<Translate>
				{({ translate }) => (
					<SelfExclusionWrapper className="two-factor-auth">
						<div className="two-factor-auth-header">{translate("Self Exclusion")}</div>
						<div className="two-factor-auth-container">
							<p>{translate("SELF_EXCLUSION_DESC")}</p>
						</div>
						{this.state.selfExcluded ? (
							<>
								<SelfExcludedButton>
									{translate("selfExclusion.notice", {
										date: moment(this.state.selfExclusionStartDate).format(
											"DD.MM.YYYY, HH:mm"
										),
										day: this.state.selfExclusionDays,
									})}
								</SelfExcludedButton>
								<SelfExcludedInfo>
									{translate("SELF_EXCLUSION_INFO")}
								</SelfExcludedInfo>
							</>
						) : (
							<Form
								ref={this.formRef}
								onFinish={this.handleSelfExclusion.bind(this)}
								onValuesChange={this.handleFormValuesChange}>
								<Row
									xs={24}
									gutter={10}>
									<Col xs={12}>
										<Form.Item
											label={translate("FOR_DAYS")}
											name="selfExculsionDays"
											rules={[
												{
													required: true,
													message: translate("Please input day!"),
													pattern: new RegExp(/^[0-9]+$/),
												},
											]}>
											<Input
												type="number"
												min={1}
												max={1825}
											/>
										</Form.Item>
									</Col>
									<Col xs={12}>
										<Form.Item>
											<Button
												htmlType="submit"
												type="submit"
												className="two-factor-auth-exclude-btn"
												style={{
													opacity: this.formRef.current?.getFieldValue(
														"selfExculsionDays"
													) // Use the ref here
														? 1
														: 0.5,
												}}
												disabled={this.state.isButtonDisabled}>
												{translate("EXCLUDE NOW")}
											</Button>
										</Form.Item>
									</Col>
								</Row>
							</Form>
						)}
					</SelfExclusionWrapper>
				)}
			</Translate>
		);
	}
}
const mapStateToProps = () => ({});

const mapDispatchToProps = {
	selfExclusion,
	getUserInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelfExclusion);
